import { observer } from "mobx-react-lite"
import React, { FC } from "react"
import { Appearance, ImageStyle, View, ViewStyle } from "react-native"
import { AutoImage, Screen, Text } from "../../../components"
// import { useStores } from "../../models"
import { CompositeScreenProps } from "@react-navigation/native"
import { color, images } from "../../../theme"

const ROOT: ViewStyle = {
  flexGrow: 1,
  paddingBottom: 20,
}

const IMG_LOGO: ImageStyle = {
  width: '50%',
  alignSelf: 'center',
  height: 80,
  marginVertical: 30,
  resizeMode: 'contain'
}

const BORDER: ViewStyle = {
  borderWidth: 1,
  borderColor: color.palette.gray200,
  marginTop: 10,
  marginBottom: 20
}
const BOTTOM: ViewStyle = {
  marginTop: 30
}


export const InfoAppScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function InfoAppScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props

  // Pull in one of our MST stores
  // const { someStore, anotherStore } = useStores()

  return (
    <Screen style={ROOT} preset="scroll" colorScheme={colorScheme} backgroundBar={color.primary} statusBar="light-content">
      <AutoImage source={images.logo_blue} style={IMG_LOGO} />
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="10px" tx="infoAppScreen.header" />
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="10px" tx="infoAppScreen.credit"/>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="10px" tx="infoAppScreen.madeIn" />
      <View style={BORDER} />
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="10px" tx="infoAppScreen.thanks" />
      <View style={BOTTOM} />
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">Agus Dwiono</Text>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">Agus Subagyo</Text>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">Andri Pranata Suryana</Text>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">Aris Muzaqi</Text>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">Arman Faries</Text>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">Candra Yunianto</Text>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">Dirwansyah A.</Text>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">Edmon Farwistia</Text>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">Fadli Robbi Rizkiaini</Text>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">Faisal</Text>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">Feri Musmialudin</Text>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">Khamal Rachmanda</Text>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">Muhammad Sofyan</Text>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">R. Aken Yugo</Text>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">Riano</Text>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">Ritzky Mario</Text>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">Sugianto Limanto</Text>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">Taufik Afandi</Text>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">Zainuri Ihsan</Text>
      <View style={BOTTOM} />
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">Loading animation</Text>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">by Hussain Trawadi on LottieFiles:</Text>
      <Text preset="body1" color={color.palette.darkGrey} textAlign="center" mb="5px">https://lottiefiles.com/55902-loading</Text>
    </Screen>
  )
})
